import { create } from 'zustand';
import { m, getDayContext } from '../utils/dateUtils';
import { sendDate } from '../channels/dateChannel';

function getSelectedDate() {

    try {

        const saved = localStorage.getItem('selectedDate');

        return saved
            ? m(saved)
            : m();

    } catch {

        return m();

    }

}

function saveSelectedDate(date) {

    try {

        localStorage.setItem('selectedDate', m(date).format('YYYY-MM-DD'));

    } catch {}

}

function buildDateState(selectedDate) {
    
    const currentDayContext = getDayContext(selectedDate);

    const nextDayContext = getDayContext(selectedDate, 1);

    const isToday =
        selectedDate.isSame(
            m(),
            'day'
        );

    const today = selectedDate.format('YYYY-MM-DD');

    const tomorrow = nextDayContext.date.format('YYYY-MM-DD');

    return {

        selectedDate,

        isToday,

        today,

        tomorrow,

        currentDayContext,

        nextDayContext,

        currentDayLabel: isToday
            ? `HOJE (${selectedDate.format('DD/MM/YYYY')})`
            : `${currentDayContext.nome} (${selectedDate.format('DD/MM/YYYY')})`,

        nextDayLabel:
            `${nextDayContext.nome} (${nextDayContext.date.format('DD/MM/YYYY')})`,

        
        currentDayShortLabel:
            isToday
                ? 'HOJE'
                : currentDayContext.nome,

        nextDayShortLabel:
            isToday
                ? 'AMANHÃ'
                : nextDayContext.nome

    };

}

const initialDate = getSelectedDate();

export const useDateStore = create((set) => ({

    ...buildDateState(initialDate),

    autoOperationalRange: true,

    setSelectedDate: (date, broadcast = true, manual = true) => {

        const selectedDate = m(date);

        saveSelectedDate(selectedDate);

        set({
            ...buildDateState(selectedDate),

            ...(manual && {
                autoOperationalRange: false
            })
        });

        if(broadcast){
            const payload = {
                selectedDate: selectedDate.format('YYYY-MM-DD'),
                manual
            }
            sendDate(payload);
        }

    },

    setAutoOperationalRange: value => {
        set({
            autoOperationalRange: value
        });
    },

    resetSelectedDate: () => {
        
        localStorage.removeItem('selectedDate');

        set({
            ...buildDateState(m()),
            autoOperationalRange: true
        });

    }

}));